module.exports = __webpack_public_path__ + "Logo_no_tagline_white-116-16-98390bf2ca37a6ef65a32c0df9193dae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Logo_no_tagline_white-116-16.png
// module id = 1126
// module chunks = 1